import { Info } from "lucide-react";
import { Card } from "@components/ui/card";

export function PlaceHolder() {
  return (
    <Card className="hover:shadow-lg transition-shadow duration-200 overflow-hidden p-6 border border-gray-800">
      <h2 className="text-lg font-semibold font-heading mb-4 flex items-center text-superone-charcoal">
        <Info className="mr-2 h-5 w-5 text-pink-500" />
        Placeholder
      </h2>
      <div className="flex flex-col gap-4">
        <div className="flex items-center">
          <span className="text-yellow-700 bg-yellow-100 rounded px-2 py-1 font-medium mb-4 inline-block">
            Please check back later for updates.
          </span>
        </div>
      </div>
    </Card>
  );
}
